import apiClient from "../../../services/apiClient";

const promiseCache = {};

export const getPubmedArticles = (pubId) => {
  if (!promiseCache[pubId]) {
    const result = apiClient.getPublication(pubId).toPromise();
    promiseCache[pubId] = result;
    return result;
  }

  const result = Promise.resolve(promiseCache[pubId]);
  return result;
};
